import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_RecursiveILOsCheckbox = _resolveComponent("RecursiveILOsCheckbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.iloId,
        class: "mx-5"
      }, [
        (_openBlock(), _createBlock(_component_v_checkbox, {
          class: _normalizeClass(`mt-0 word-break-all ${_ctx.isRightAlignment ? 'text-align-right' : 'text-align-left'}`),
          "hide-details": "auto",
          color: "primary",
          "onUpdate:modelValue": ($event: any) => (_ctx.onChangeCheckBox({ isSelected: $event, item })),
          disabled: item.unremovable,
          "model-value": _ctx.isParentSelected(item),
          label: item.description,
          key: item.iloId
        }, null, 8, ["class", "onUpdate:modelValue", "disabled", "model-value", "label"])),
        (item.children && Object.values(item.children).length > 0)
          ? (_openBlock(), _createBlock(_component_RecursiveILOsCheckbox, {
              key: 0,
              onIloCheckboxChange: _ctx.onChangeCheckBox,
              items: Object.values(item.children)
            }, null, 8, ["onIloCheckboxChange", "items"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}